import { CSSProperties } from "react";


export interface DashboardButtonProps {
    onClick?: (e: any) => void;
    icon?: string;
    imageUrl?: string;
    className?: string;
    caption?: string;
    description?: string;
    color?: string;
    style?: CSSProperties;
    id?: string;
    disable?: boolean;
}


/**
 * Renders a dashboard tile styled as an icon button with optional caption and icon.
 * @param props - Visual configuration and click handler for the button.
 * @returns A clickable tile that respects disabled state and custom styling.
 */
export function DashboardButton(props: DashboardButtonProps) {
    const tileStyle: CSSProperties = {
        ...props.style,
        ...(props.color ? { borderColor: props.color } : {}),
    };

    return (
        <div id={props.id} className={`fbx-icon-button ${props.disable ? "fbx-icon-button-disabled" : ""} ${props.className}`} style={tileStyle} onClick={props.disable ? undefined : props.onClick}>
            <div className="fbx-icon-button-contents fbx-center" style={{ flexDirection: "column", textAlign: "center" }}>
                {props.caption ?
                    <div className="fbx-icon-button-caption">
                        {props.caption}
                    </div> : undefined}
                {props.description ?
                    <div style={{ fontSize: 12, marginTop: 4, marginBottom: 8, opacity: 0.8 }}>
                        {props.description}
                    </div> : undefined}
                {props.imageUrl ?
                    <div className="flex justify-content-center">
                        <img src={props.imageUrl} alt="" className="fbx-icon-button-image fbx-center flex" />
                    </div> : undefined}
                {props.icon ?
                    <span className="material-icons" style={props.color ? { color: props.color } : undefined}>{props.icon}</span>
                    : undefined}
            </div>
        </div>
    )
}
